
<script>
import BarList from '../components/bar-list'
import NcmForm from './ncm-form'
import { getText, formatDate, formatValue } from '../shared/utils'
import { SysVars } from '../main';

export default {
    data () {

        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            ncm: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            nextPage: '',
        }
    },

    computed: {
        ncmList: function () {
            return this.$store.getters.getNcmList
        },
    },

    filters: {
        format: function (value) {
            return formatValue(value, 2)
        },

    },

    methods: {
        handleEdit (ncm) {
            //abre a tela de edicao
            this.crud = SysVars.crudU;
            this.ncm = ncm
            this.showForm = true;
        },
        
        handleNew () {
            //inclusao de registro
            this.crud = SysVars.crudI
            this.ncm = ''
            this.showForm = true;
        },

        handleMore () {
            this.offset = 'offset=' + this.$store.getters.getNextPage
            this.loadData()
        },

        closeForm() {
            this.showForm = false
            this.loadData()
        },

        search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"ncm":{"$like":"%25' + value + '%25"}},{"descricao":{"$like":"%25' + value + '%25"}}]}'
            this.nextPage = ''
            this.loadData()
        },

        loadData() {
            this.$store.dispatch('loadNcmList', { filter: this.filter, page: this.nextPage } )
        }

    },

    components: {
        BarList, NcmForm
    },

    created () {
        this.showForm = false
        this.loadData()
    }

}

</script>

<template>
    <div>
        <div id="list" v-show="!showForm"> 
            <bar-list
                :refresh-button="true" 
                :new-button="true" 
                :pdf-button="false"
                :xls-button="false"
                single-entity="NCM" 
                plural-entity="NCMs"
                @search="search"
                @new="handleNew"
                @refresh="loadData"
                title-search="Pesquise pelo NCM ou pela descrição">
            </bar-list>
            <br>
            <div class="default-container">
                <alert v-if="ncmList.length == 0" type="norecord"></alert>
                <div class="mainbox" v-for="ncm in ncmList" v-bind:key="ncm.ncm">
                    <div class="mark-green"></div>
                    <div class="box">
                        <div class="row">
                            <div class="col-md-2 col-3">
                                <label class="lbl-list">NCM</label>
                                <span class="data-list">{{ ncm.ncm }}</span>
                            </div>
                            <div class="col-md-4 col-9">
                                <label class="lbl-list"> {{metadata.ncm.descricao.label}} </label>
                                <span class="data-list">{{ ncm.descricao }}</span>
                            </div>
                            <div class="col-md-2 col-3" style="float: left">
                                <label class="lbl-list"> {{metadata.ncm.aipi.label}}: </label><span class="data-list">{{ ncm.aipi | format }}</span>
                            </div>
                            <div class="col-md-2 col-3" style="float: left">
                                <label class="lbl-list"> {{metadata.ncm.cest.label}}: </label><span class="data-list">{{ ncm.cest }}</span>
                            </div>
                            <div class="col-md-2 col-12">
                                <bar-grid 
                                    :options="{barDefault: true, btnView: true, btnEdit: true}" 
                                    :moreActions="[]" 
                                    v-on:edit="handleEdit(ncm.ncm)" 
                                    v-on:view="handleEdit(ncm.ncm, true)">
                                </bar-grid>
                            </div>
                        </div>
                        <div class="row">
                        </div>
                    </div>
                </div>
                <div class="col" v-if="nextPage > 0">
                        <v-button label="Carregar Mais" title="" @click="handleMore"></v-button>
                </div>
            </div>
        </div>
        <ncm-form v-if="showForm" :index="this.ncm" :crud="this.crud" v-on:closeform="closeForm"></ncm-form>
    </div>
</template>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/ncm-list.vue